/* eslint-disable */
import toast from '../../../services/toast';
import { mapGetters } from 'vuex';
var $ = window.jQuery = require('jquery');
export default {
  name: 'public-quiz-question-answer-create',
  components: {},
  props: [],
  data() {
    return {
      QuizList:null,
      quizDetailsEdit:null,
      quizData:[{
        quizId:''
      }],
      submitted:false,
      questionData:[{
        content:'',
      }],
      quizQuesDetails:'',
      radio_option:'',
      content1:'',
      is_correct1:Boolean,
      content1_isValid:false,
      index1:1,
      content2:'',
      is_correct2:Boolean,
      index2:2,
      content3:'',
      is_correct3:Boolean,
      index3:3,
      content4:'',
      is_correct4:Boolean,
      index4:4,
      content:'',
      is_correct:'',
      index:'',
      pub_catID:'',
      positive_points:'',
      negative_points:'',
      difficulty_level:'',
      estimated_solve_time:'',
    }
  },
  computed: {
    ...mapGetters([
      'getQuizDetailsByIdDataState'
    ]),
    getQuizQuesdetails() {
      this.quizQuesDetails = this.$store.getters.getQuizDetailsByIdDataState
      return this.quizQuesDetails
    },
  },
  mounted() {
    this.pub_catID = this.$route.params.quiz_catId,
    this.getQuizQuesdetails
    this.quizData.quizId = this.$route.params.quizId;
    this.createEditor()
  },
  methods: {
    createEditor() {
      CKEDITOR.replace('Questioncontent',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['Questioncontent'].on('change', () => {
        var content1Length = CKEDITOR.instances['Questioncontent'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #Questioncontent').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #Questioncontent').removeClass('is-invalid')
          this.questionData.content = CKEDITOR.instances['Questioncontent'].getData()
        }else{
          $('.custom_editor_for_option #Questioncontent').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #Questioncontent').addClass('is-invalid')
          this.questionData.content = ''
        }
      })
      CKEDITOR.replace('content1',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content1'].on('change', () => {
        var content1Length = CKEDITOR.instances['content1'].getData().replace(/<[^>]*>/gi, '').length;
        if(content1Length > 0){
          $('.custom_editor_for_option #content1').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content1').removeClass('is-invalid')
          this.content1 = CKEDITOR.instances['content1'].getData()
        }else{
          $('.custom_editor_for_option #content1').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content1').addClass('is-invalid')
          this.content1 = ''
        }
      })
      CKEDITOR.replace('content2',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content2'].on('change', () => {
        var content2Length = CKEDITOR.instances['content2'].getData().replace(/<[^>]*>/gi, '').length;
        if(content2Length > 0){
          $('.custom_editor_for_option #content2').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content2').removeClass('is-invalid')
          this.content2 = CKEDITOR.instances['content2'].getData()
        }else{
          $('.custom_editor_for_option #content2').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content2').addClass('is-invalid')
          this.content2 = ''
        }
      })
      CKEDITOR.replace('content3',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content3'].on('change', () => {
        var content3Length = CKEDITOR.instances['content3'].getData().replace(/<[^>]*>/gi, '').length;
        if(content3Length > 0){
          $('.custom_editor_for_option #content3').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content3').removeClass('is-invalid')
          this.content3 = CKEDITOR.instances['content3'].getData()
        }else{
          $('.custom_editor_for_option #content3').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content3').addClass('is-invalid')
          this.content3 = ''
        }
      })
      CKEDITOR.replace('content4',{
        extraPlugins: 'mathjax',
        mathJaxLib: 'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.4/MathJax.js?config=TeX-AMS_HTML',
        height:150,
      });
      CKEDITOR.instances['content4'].on('change', () => {
        var content4Length = CKEDITOR.instances['content4'].getData().replace(/<[^>]*>/gi, '').length;
        if(content4Length > 0){
          $('.custom_editor_for_option #content4').attr('aria-invalid', 'false')
          $('.custom_editor_for_option #content4').removeClass('is-invalid')
          this.content4 = CKEDITOR.instances['content4'].getData()
        }else{
          $('.custom_editor_for_option #content4').attr('aria-invalid', 'true')
          $('.custom_editor_for_option #content4').addClass('is-invalid')
          this.content4 = ''
        }
      })
    },
    validateCreateQuizBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        this.submitted = true;
        if(this.radio_option == 'option1'){
          this.is_correct1 = true
        }
        if(this.radio_option == 'option2'){
          this.is_correct2 = true
        }
        if(this.radio_option == 'option3'){
          this.is_correct3 = true
        }
        if(this.radio_option == 'option4'){
          this.is_correct4 = true
        }
        if (result) {
          this.loadingSumbitted = false
          let data = {
            quiz:  this.$route.params.quizId,
            content: this.questionData.content,
            type:3,
            options:[{
              content:this.content1,
              is_correct: this.is_correct1,
              index: this.index1
            },
            {
              content:this.content2,
              is_correct:this.is_correct2,
              index:this.index2
            },
            {
              content:this.content3,
              is_correct:this.is_correct3,
              index:this.index3
            },
            {
              content:this.content4,
              is_correct:this.is_correct4,
              index:this.index4
            }],
            difficulty_level:this.difficulty_level,
          }
          if(this.positive_points != null && this.positive_points != ''){
            data.positive_points = this.positive_points;
          }
          if(this.negative_points != null && this.negative_points != ''){
            data.negative_points = this.negative_points;
          }
          if(this.estimated_solve_time != null && this.estimated_solve_time != ''){
            data.estimated_solve_time = this.estimated_solve_time;
          }
          this.$store.dispatch('createQuizQuesFun', data)
          .then((res) => {
            toast.success(res.data.msg);
            this.content1 = ''
            this.content2 = ''
            this.content3 = ''
            this.content4 = ''
            this.difficulty_level = ''
            this.questionData.content = ''
            this.positive_points = ''
            this.negative_points = ''
            this.estimated_solve_time = ''
            this.$router.push('/course/contest/quizzes/' + this.pub_catID + '/question-answer/' + this.quizData.quizId + /list/)
            this.$validator.reset();
            })
            .catch((err) => {
            })
          return
        }
      });
    },
  },
  beforeMount() {
  },
  watch: {
    getQuizQuesdetails() {
      return this.$store.getters.getQuizDetailsByIdDataState
    }
  },
}